// check if the pin.length === 4 and contains only numbers
export const checkPinFormat = (pin) => {
	const isValid = pin.toString().length === 4 && pin.match(/^\d+$/);
	return isValid;
};
